#import "./AddressFull.graphql"
#import "./SearchIndexFull.graphql"
#import "./TimestampsFull.graphql"

fragment CustomerFull on Customer {
  id
  pricingLevel
  cognitoId
  cognitoProvider
  fullName
  email
  phoneNumber
  invoiceEmail
  deliveryAddresses {
    ...AddressFull
  }
  billingAddress {
    ...AddressFull
  }
  gdprApprovedAt
  company {
    cin
    name
    vat
  }
  locale
  allowPaymentOnInvoice
  fakturoidSubjectId
  fakturoidOssSubjectId
  blockedAt
  blockedBy
  ...TimestampsFull
  ...SearchIndexFull
}
